<script setup lang="ts">
import type { Url } from '@global-types/url.ts';
import Typography from '@components/Typography.vue';

interface SubmenuItemProps {
  link?: Url,
  isActive?: boolean,
}

withDefaults(defineProps<SubmenuItemProps>(), {
  isActive: false,
});
</script>

<template>
  <a
    :href="link"
    :class="[
      'submenu-item',
      { 'submenu-item--active': isActive },
      'rounded-lg',
      'h-10',
      'px-4',
      'flex items-center',
      'select-none no-underline',
      { 'cursor-default': isActive },
    ]"
  >
    <Typography :variant="isActive ? 'body-small-bold' : 'body-small'">
      <slot />
    </Typography>
  </a>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;

.submenu-item {
  &--active {
    background-color: $colorBlueLightest;
  }

  @media (hover: hover) {
    &:hover {
      background-color: $colorBlueLightest;
    }
  }
}
</style>
